<template>
  <div class="flex items-center gap-x-1">
    <base-obligatory-icon v-if="required" />
    <span :class="{ 'text-primary-800': edited }">{{ label }}</span>
    <BaseIcon
      v-if="edited"
      size="sm"
      name="editpencil"
      :title="$t('invoices.field_edited')"
      class="text-primary-800"
    />
  </div>
</template>

<script>
export default {
  name: 'base-editable-field-label',
  props: {
    label: {
      type: String,
      required: true,
    },
    edited: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
